import React, { useEffect } from "react";
import './maskBackground.css';

interface MaskBackgroundOverflowProps {
    zIndex?: number;
    closeFunction?: () => void;
}

const MaskBackgroundOverflow: React.FC<MaskBackgroundOverflowProps> = ({ zIndex = 1, closeFunction }) => {
    useEffect(() => {
        const body = document.body;
        const html = document.documentElement;

        const previousBodyOverflow = body.style.overflow;
        const previousHtmlOverflow = html.style.overflow;
        const previousBodyPaddingRight = body.style.paddingRight;

        const scrollbarWidth =
            window.innerWidth - html.clientWidth;

        body.style.overflow = "hidden";
        html.style.overflow = "hidden";

        if (scrollbarWidth > 0) {
            const currentPaddingRight =
                Number.parseFloat(
                    window.getComputedStyle(body).paddingRight
                ) || 0;

            body.style.paddingRight =
                `${currentPaddingRight + scrollbarWidth}px`;
        }

        return () => {
            body.style.overflow = previousBodyOverflow;
            html.style.overflow = previousHtmlOverflow;
            body.style.paddingRight = previousBodyPaddingRight;
        };
    }, []);

    return (
        <div
            className="containerMaskBackground"
            style={{ zIndex }}
            onClick={() => {
                if (closeFunction) closeFunction();
            }}
        />
    );
};

export default MaskBackgroundOverflow;
